var React = require('react');

function ListBulletsLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.464 4.465a5 5 0 117.072 7.07 5 5 0 01-7.072-7.07zM5 5a3 3 0 100 6 3 3 0 000-6zm11 3a1 1 0 011-1h30a1 1 0 110 2H17a1 1 0 01-1-1zM1.464 20.465a5 5 0 117.072 7.07 5 5 0 01-7.072-7.07zM5 21a3 3 0 100 6 3 3 0 000-6zm11 3a1 1 0 011-1h30a1 1 0 110 2H17a1 1 0 01-1-1zM1.464 36.465a5 5 0 117.072 7.07 5 5 0 01-7.072-7.07zM5 37a3 3 0 100 6 3 3 0 000-6zm11 3a1 1 0 011-1h30a1 1 0 110 2H17a1 1 0 01-1-1z"}));
}

ListBulletsLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ListBulletsLight;

ListBulletsLight.default = ListBulletsLight;
